import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { TeamModelGo } from "./team.model";
import { environment } from "../../../environments/environment";
import { bufferCount, concatAll, from, map, of } from "rxjs";
import { UserModel, UserModelGo } from "../../core/services/user/user.model";
import { authorizeHttp } from "../../core/util/authorize-http";
import { AuthService } from "../../core/services/auth/auth.service";

@Injectable({providedIn: 'root'})
export class TeamService {

  http = authorizeHttp(inject(HttpClient), inject(AuthService).accessTokenReadOnly);

  getUsersOfTeam(teamID: string) {
    return this.http.get<TeamModelGo[]>(`${environment.baseUrlRds}/data/teams/${teamID}/`)
    .pipe(map(teams => {
      if (teams.length) {
        return from(teams[0].members)
        .pipe(map(memberID =>
          this.http.get<UserModelGo[]>(`${environment.baseUrlRds}/data/users/${memberID}/`)
          .pipe(map(array => mapUserFromGo(array.filter(Boolean)[0])))
        ), concatAll(), bufferCount(teams[0].members.length))
      }
      return of(<UserModel[]>[]);
    }), concatAll());
  }

  addUserToTeam(teamID: string, userID: string) {
    this.http.post(`${environment.baseUrlRds}/data/teams/${teamID}/members/${userID}/`, null).subscribe();
  }

  removeUserFromTeam(teamID: string, userID: string) {
    this.http.delete(`${environment.baseUrlRds}/data/teams/${teamID}/members/${userID}/`).subscribe();
  }

}

export function mapUserFromGo(user: UserModelGo) {
  if (!user) { return null; }
  return <UserModel>{
    id: user.id,
    givenName: user.givenName,
    familyName: user.familyName,
    email: user.email,
    picture: '',
  };
}
